export default __webpack_public_path__ + "static/media/webTraderIcon4.97729b29.webp";